import { Component, computed, inject, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { ModalComponent } from '../modal/modal.component';
import { ModalRef } from '../modal/modal-ref';
import { MODAL_DATA } from '../modal/modal-tokens';

export interface SuccessModalData {
  title?: string;
  message?: string;
  subtitle?: string;
  buttonLabel?: string;
}

@Component({
  selector: 'app-success-modal',
  standalone: true,
  imports: [TranslateModule, ButtonComponent, ModalComponent],
  templateUrl: './success-modal.component.html',
  styleUrl: './success-modal.component.scss',
})
export class SuccessModalComponent {
  private modalData = inject(MODAL_DATA, { optional: true }) as SuccessModalData | null;
  private modalRef = inject(ModalRef, { optional: true });

  // Inputs (template-mode backward compat)
  title = input('SUCCESS.TITLE');
  message = input('SUCCESS.MESSAGE');
  subtitle = input('');
  buttonLabel = input('SUCCESS.BUTTON');

  // Outputs (template-mode backward compat)
  continue = output<void>();
  close = output<void>();

  // Effective values — prefer MODAL_DATA, fall back to inputs
  readonly effectiveTitle = computed(() => this.modalData?.title ?? this.title());
  readonly effectiveMessage = computed(() => this.modalData?.message ?? this.message());
  readonly effectiveSubtitle = computed(() => this.modalData?.subtitle ?? this.subtitle());
  readonly effectiveButtonLabel = computed(() => this.modalData?.buttonLabel ?? this.buttonLabel());

  onContinue(): void {
    if (this.modalRef) {
      this.modalRef.close('continue');
    } else {
      this.continue.emit();
    }
  }

  onClose(): void {
    if (this.modalRef) {
      this.modalRef.close();
    } else {
      this.close.emit();
    }
  }
}
